var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1749798168484,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5247,
    width: 64,
    height: 64,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821.5 394.1c-15.8-9.1-36.1-3.7-45.2 12.1l-16.5 28.6-16.5 28.6-132.4 228.8-49.6 85.8c-45.7 79-146.9 106.1-226 60.5-8.7-5-16.6-10.9-24-17.2-2.3-1.9-4.4-3.9-6.5-5.9-5.2-4.9-10-10.1-14.4-15.6-2.3-2.8-4.6-5.6-6.8-8.6-4.1-5.8-7.8-11.8-11.1-18-2.6-4.9-4.7-9.8-6.8-14.9-0.9-2.3-1.8-4.6-2.6-7-15.9-44.2-13.7-94.5 11.6-138.4l33.1-57.2 16.5-28.6 115.8-200.3 16.5-28.6 49.6-85.8c27.4-47.4 88.1-63.6 135.6-36.3 47.5 27.4 63.8 88 36.3 135.4l-16.5 28.6-19.5 33.9-13.5 23.3-16.6 28.6L446.6 712c-9.1 15.8-29.4 21.2-45.2 12.1-15.8-9.1-21.3-29.3-12.1-45.1l99.3-171.6 19.6-33.9 63.1-109.2c9.1-15.8 3.7-36-12.1-45.1-15.8-9.1-36.1-3.7-45.2 12.1l-63.1 109.2-19.6 33.9L332 646c-27.4 47.4-11.1 108 36.3 135.4 47.5 27.4 108.2 11.1 135.6-36.3l115.5-199.6 33.5-57.9 82.7-143c45.7-79 18.6-180-60.6-225.6-79.1-45.6-180.3-18.5-226 60.5l-33.1 57.2-132.4 228.7-33.1 57.2-33.1 57.2c-64 110.6-26 252 84.8 315.9 110.8 63.8 252.5 26 316.5-84.6l182-314.7 16.5-28.6 16.5-28.6c9.2-15.8 3.8-36-12.1-45.1z",
    "p-id": 5248,
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj);
export default __webpack_public_path__ + "static/media/fj.8d628d4ca31f3e05266021e82e35cb53.svg";
export { ForwardRef as ReactComponent };